import {useReportUserVisibleError} from '@github-ui/copilot-browser-latency/use-report-user-visible-error'
import {Button} from '@primer/react'
import {Blankslate} from '@primer/react/experimental'
import {ComposeIcon} from '@primer/octicons-react'
import {useEffect, useRef} from 'react'
import {ReadOnlyConversationNotice} from './ReadOnlyConversationNotice'
import styles from './ChatContinuationUnavailable.module.css'

const heading = 'This conversation is no longer available to continue'
const description = 'You can still review its history. Start a new conversation to keep chatting with Copilot.'

export function ChatContinuationUnavailable({
  onStartNew,
  focusOnMount = false,
  compact = false,
}: {
  onStartNew?: () => void
  focusOnMount?: boolean
  compact?: boolean
}) {
  const focusRef = useRef<HTMLDivElement>(null)
  useReportUserVisibleError('task_unavailable')

  useEffect(() => {
    if (focusOnMount) focusRef.current?.focus()
  }, [focusOnMount])

  return (
    <div ref={focusRef} tabIndex={-1} data-testid="continuation-unavailable-focus-target">
      {compact ? (
        <ReadOnlyConversationNotice
          message={
            <>
              <h2 className={styles.heading}>{heading}</h2>
              <p className={styles.description}>{description}</p>
            </>
          }
          action={
            onStartNew ? (
              <Button variant="primary" leadingVisual={ComposeIcon} onClick={onStartNew}>
                Start a new conversation
              </Button>
            ) : null
          }
        />
      ) : (
        <Blankslate>
          <Blankslate.Heading>{heading}</Blankslate.Heading>
          <Blankslate.Description>{description}</Blankslate.Description>
          {onStartNew ? (
            <Blankslate.PrimaryAction onClick={onStartNew}>Start a new conversation</Blankslate.PrimaryAction>
          ) : null}
        </Blankslate>
      )}
    </div>
  )
}

ChatContinuationUnavailable.displayName = 'ChatContinuationUnavailable'
